export default __webpack_public_path__ + "0ab0184f879cd21b3d3e4a17730c2488.png";